import React from 'react';
import { ChevronDown } from 'lucide-react';
import { Button } from '../ui/Button';
export function ConcreteFinishesHero() {
  const scrollToFinishes = () => {
    const element = document.getElementById('finish-options');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="relative bg-slate-900 py-20 md:py-32 overflow-hidden min-h-[70vh] flex items-center" data-id="element-115">
      {/* Video Background */}
      <div className="absolute inset-0 z-0" data-id="element-116">
        <div className="absolute inset-0 bg-slate-900/70 z-10" data-id="element-117"></div>
        <video autoPlay loop muted playsInline className="h-full w-full object-cover" poster="https://images.unsplash.com/photo-1483664852095-d6cc6870702d?q=80&w=2070&auto=format&fit=crop" data-id="element-118">
          <source src="https://cdn.magicpatterns.com/uploads/gVfFpdrefsXLf2ttSaXFT7/2e5fd22b26ef49c6ad1f7e7527a79d9f.undefined" type="video/mp4" data-id="element-119" />
          Your browser does not support the video tag.
        </video>
        <div className="absolute inset-0 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 -z-10" data-id="element-120"></div>
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-20 text-center" data-id="element-121">
        <div className="max-w-3xl mx-auto space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-700" data-id="element-122">
          <div className="inline-flex items-center rounded-full border border-primary/30 bg-primary/10 px-3 py-1 text-sm font-medium text-primary-foreground mb-4 backdrop-blur-sm" data-id="element-123">
            <span className="flex h-2 w-2 rounded-full bg-primary mr-2" data-id="element-124"></span>
            Traction &bull; Durability &bull; Aesthetics
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-white drop-shadow-lg" data-id="element-125">
            Choosing the Right Concrete Finish for Your Heated Surface
          </h1>

          <p className="text-xl text-slate-200 leading-relaxed drop-shadow-md" data-id="element-126">
            Will it be slippery? Will it crack after 2 winters? Will it look
            good long-term? Let us help you choose honestly.
          </p>

          <p className="text-base text-slate-300 max-w-2xl mx-auto drop-shadow-md" data-id="element-127">
            The finish you choose affects traction, durability, maintenance, and
            how your heated system performs. Here is what actually matters.
          </p>

          <div className="pt-8 flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-128">
            <Button size="lg" onClick={scrollToFinishes} className="min-w-[200px] border border-white shadow-lg" data-id="element-129">
              Explore Finishes
            </Button>
            <Button variant="outline" size="lg" className="min-w-[200px] bg-white/5 border-white/20 text-white hover:bg-white/20 hover:text-white backdrop-blur-sm" onClick={() => {
            const element = document.getElementById('quote-form');
            if (element) element.scrollIntoView({
              behavior: 'smooth'
            });
          }} data-id="element-130">
              Get a Recommendation
            </Button>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce text-white/50 z-20" data-id="element-131">
        <ChevronDown className="h-8 w-8" data-id="element-132" />
      </div>
    </section>;
}